"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCi = void 0;
const format_1 = require("../format");
function validateCi(userDocument) {
    const docnumber = (0, format_1.formatStringToNumber)(userDocument);
    if (docnumber !== userDocument) {
        return false;
    }
    if ((0, format_1.isRepeatedDigitText)(docnumber)) {
        return false;
    }
    if (docnumber.length !== 7 && docnumber.length !== 8) {
        return false;
    }
    const lastDigit = parseInt(docnumber[docnumber.length - 1], 10);
    const ALGORITHM_FACTORS = [2, 9, 8, 7, 6, 3, 4];
    let sum = 0;
    for (let i = 0; i < docnumber.length - 1; i += 1) {
        const num = parseInt(docnumber.substring(i, i + 1), 10);
        sum += num * ALGORITHM_FACTORS[i];
    }
    const checkDigit = (10 - (sum % 10)) % 10;
    return lastDigit === checkDigit;
}
exports.validateCi = validateCi;
